import { record } from 'fp-ts';
import { Banner, Divider, Stack, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { Loader } from '@mews-commander/ui';
import { LocalPolicyFields, RateSelectionFields } from '../../fields';
import { useGetCollidingRates } from '../../../../queries';
import { useCurrentRateGroupContext } from '../../../../contexts';
import { LocalCreatePolicyLinks } from '../../DefaultPolicyForm/LocalCreatePolicyLinks';

interface Props {
    isExceptionSectionDisabled?: boolean;
    policyId?: string;
    showExceptionTypeSelection?: boolean;
}

export const PolicyExceptionsFormDetailsFields = ({
    isExceptionSectionDisabled,
    policyId,
    showExceptionTypeSelection,
}: Props) => {
    const queryResult = useGetCollidingRates(policyId);
    const { settlementCurrencyCode, enterpriseId } = useCurrentRateGroupContext();
    const areRatesColliding = !!queryResult.data && !record.isEmpty(queryResult.data);

    return (
        <Stack vertical spacing="300">
            {queryResult.isLoading ? <Loader /> : null}
            {queryResult.isSuccess ? (
                <>
                    {showExceptionTypeSelection || !isExceptionSectionDisabled ? (
                        <>
                            {areRatesColliding ? (
                                <Banner
                                    variant="warning"
                                    primaryText={lt('PolicyExceptionFormExceptionOverlappingWarningTitle')}
                                    secondaryText={lt('PolicyExceptionFormExceptionOverlappingWarningDescription')}
                                />
                            ) : null}
                            <Stack vertical spacing="200">
                                <Typography textStyle="titleSmallStrong" as="div">
                                    {areRatesColliding
                                        ? lt('PolicyExceptionFormChooseRatesTitle')
                                        : lt('PolicyExceptionFormExceptionTypeTitle')}
                                </Typography>
                                <RateSelectionFields
                                    policyId={policyId}
                                    showExceptionTypeSelection={showExceptionTypeSelection}
                                    disabledRates={areRatesColliding ? queryResult.data : undefined}
                                />
                            </Stack>
                            <Divider />
                        </>
                    ) : null}
                </>
            ) : null}
            <Stack vertical spacing="200">
                <Typography textStyle="titleSmallStrong" as="div">
                    {lt('PolicyExceptionFormPolicyTitle')}
                </Typography>
                <LocalPolicyFields settlementCurrencyCode={settlementCurrencyCode} enterpriseId={enterpriseId} />
                <LocalCreatePolicyLinks />
            </Stack>
        </Stack>
    );
};
